<template>
  <Modal @close="close" :active="active" title="Esqueceu sua senha?">
    <form class="modal-recovery" @submit.prevent="submit()" ref="form">
      <div class="recovery-subtitle">Vamos criar uma nova!</div>
      <Input
        :value="email"
        @change="event => email = event"
        label="Qual o e-mail cadastrado?"
        placeholder="E-mail"
        :disabled="sending"
        :invalid="$v.email.$invalid"
      />
      <Input
        :value="password"
        @change="event => password = event"
        type="password"
        label="Digite a nova senha"
        placeholder="Senha"
        :disabled="sending"
        :invalid="$v.password.$invalid"
      />
      <Input
        :value="repassword"
        @change="event => repassword = event"
        type="password"
        label="Repita sua senha"
        placeholder="Repita sua senha"
        :disabled="sending"
        :invalid="$v.repassword.$invalid"
      />
      <Alert
        v-for="(notification, index) in notifications"
        :key="index"
        :title="notification.title"
        :icon="notification.icon"
        :type="notification.type"
      />
      <Button
        @click="submit"
        :disabled="sending"
        :loading="sending"
        type="primary"
        title="Recuperar senha"
      />
    </form>
  </Modal>
</template>

<script>
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import api from '../../services/api'

import Modal from '../Modal'
import Input from '../Input'
import Button from '../Button'
import Alert from '../Alert'
import { mapActions } from 'vuex'

export default {
  name: 'ModalRecovery',
  components: {
    Modal,
    Input,
    Button,
    Alert
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      email: '',
      password: '',
      repassword: '',
      sending: false,
      notifications: []
    }
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(4) },
    repassword: { required, sameAsPassword: sameAs('password') }
  },
  methods: {
    ...mapActions(['addAlert', 'clearAlert']),
    close (event = false) {
      this.notifications = []
      this.$refs.form.reset()
      this.$emit('close', event)
    },
    async submit () {
      this.notifications = []
      this.clearAlert()
      if (this.sending) {
        return
      }
      this.sending = true
      if (this.$v.$invalid) {
        this.notifications.push({
          type: 'danger',
          icon: 'alert-rhombus-outline',
          title: 'Por favor, verifique seus dados.'
        })
        this.sending = false
        return
      }
      try {
        const params = {}

        params.email = this.email
        params.password = this.password

        const response = await api.post('/users/reset-password', params)
        if (response.status === 204) {
          const newAlert = {
            type: 'success',
            icon: 'checkbox-marked-circle-outline',
            title: 'Verifique seu e-mail e confirme a mudança da sua senha!'
          }
          this.addAlert(newAlert)
          this.notifications.push(newAlert)
          this.$emit('close', 'confirm')
        }
      } catch (error) {
        this.notifications.push({
          type: 'danger',
          icon: 'alert-rhombus-outline',
          title: 'Por favor, verifique seus dados.'
        })
      }
      this.sending = false
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
